module.exports = __webpack_public_path__ + "images/piaggio_small24f00be661df74e4c3a964fed3c6100f.png";